<template>
  <div class="heatmap-container">
    <div class="legend-container">
      <div
        v-for="group in groups"
        :key="
          (group.lowerBound !== null ? group.lowerBound.toString() : '') +
            (group.upperBound !== null ? group.upperBound.toString() : '')
        "
        class="legend-item"
        :style="{ color: group.backgroundColor }"
      >
        <div class="color" :style="{ background: group.backgroundColor }" />
        <span
          v-if="group.lowerBound === group.upperBound && group.lowerBound !== null"
          class="legend-item-text"
        >
          {{ group.lowerBound }}
        </span>
        <span v-else class="legend-item-text">
          {{ group.lowerBound !== null ? group.lowerBound : '&lt;' }}
          {{ group.lowerBound !== null && group.upperBound !== null ? '-' : '' }}
          {{ group.upperBound !== null ? group.upperBound : '+' }}
        </span>
      </div>
    </div>
    <div class="heatmap-graph-container">
      <div class="heatmap-graph-container-without-x-labels">
        <div class="y-labels-container">
          <span v-for="label in yLabels" :key="label" class="labels">
            {{ label }}
          </span>
        </div>
        <table class="heatmap-table">
          <tr v-for="yLabel in yLabels" :key="yLabel">
            <td
              v-for="xLabel in xLabels"
              :key="xLabel"
              class="table-cell"
              :style="{ background: getColorByLabels(xLabel, yLabel) }"
            >
              <span class="tooltip">{{ findDataValue(xLabel, yLabel) }}</span>
            </td>
          </tr>
          <tr>
            <td v-for="label in xLabels" :key="label" class="labels x-label-cell">
              {{ label }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'heatmap',
  props: {
    xLabels: Array,
    yLabels: Array,
    data: Array,
    groups: Array,
  },
  data() {
    return {}
  },
  methods: {
    findDataValue(xLabel, yLabel) {
      const existingItem = this.data.find(item => item.x === xLabel && item.y === yLabel)

      return existingItem ? existingItem.value : 0
    },
    getColorByLabels(xLabel, yLabel) {
      const value = this.findDataValue(xLabel, yLabel)
      for (const group of this.groups) {
        if (group.lowerBound === null) {
          if (value <= group.upperBound) return group.backgroundColor
          continue
        }
        if (group.upperBound === null) {
          if (value >= group.lowerBound) return group.backgroundColor
          continue
        }
        if (value >= group.lowerBound && value <= group.upperBound) {
          return group.backgroundColor
        }
      }
    },
  },
}
</script>

<style scoped>
.heatmap-container {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}
.legend-container {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.heatmap-graph-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.75rem;
}
.heatmap-graph-container-without-x-labels {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}
.y-labels-container {
  display: flex;
  padding: 0.625rem 0;
  flex-direction: column;
  align-items: flex-end;
  gap: 1.25rem;
}
.legend-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.legend-item-text {
  color: #666;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.labels {
  color: #333;
  text-align: right;
  font-family: 'Source Sans Pro';
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;

  white-space: nowrap;
}
.x-label-cell {
  text-align: center;
  margin-top: 0.75rem;
}
.heatmap-table {
  border-collapse: collapse;
  border-spacing: 0;
}
.table-cell {
  position: relative;
  min-width: 0.75rem;
  max-width: 3.125rem;
  width: 3.125rem;
  height: 2.3125rem;
  border: 1px solid #f0f6fa;
}
.color {
  width: 12px;
  height: 12px;
  border-radius: 10000px;
}

.table-cell .tooltip {
  visibility: hidden;
  width: fit-content;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -10px;
  opacity: 0;
  transition: opacity 0.3s;
}

.table-cell .tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.table-cell:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
</style>
